import _ from "lodash";
import { CellRenderers } from "utils/tableUtils";

export default function EPSSScore({ epssScore }) {
  if (!_.isNil(epssScore)) {
    const displayText = `${EPSSReceiveInterceptor([epssScore])}%`;
    const fullPrecision = `${epssScore * 100}%`;
    return <div title={fullPrecision}>{displayText}</div>
  } else {
    return CellRenderers.VALUE_OR_NA();
  }
}

export const EPSSReceiveInterceptor = (scores) => {
    return scores.map((score) => (score ? +(score * 100).toFixed(3) : score));
};

export const convertEPSSScorePercentToValue = scorePercent => (scorePercent * 100).toFixed(3);

export const convertEPSSScoreValueToPercent = score => (score / 100);
